import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopSearchText = simpleSet as
  redux.reducers.calculationMode.settings.materials.countertop.searchText;

export const searchText = setCalculationModeCountertopSearchText(
  'SET_CALCULATION_MODE_COUNTERTOP_SEARCH_TEXT',
  ''
);
